<select class="form-select form-select-sm"
        id="fieldAction"
        name="fieldAction"
        [ngModel]="selectedAction"
        (ngModelChange)="fieldActionChanged($event)"
        [disabled]="disabled">
    @for (a of enabledActions; track a) {
        <option [ngValue]="a">{{ a.name }}</option>
    }
</select>
